module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112921-DealerDraft-Infinity-2Established.69f23bcf.jpeg";